{
  "en": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      },
      "confirm": {
        "question": "Sure?",
        "yes": "Yes",
        "no": "No"
      }
    }
  }
}
